import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { debounce } from 'underscore';
import AsyncSelector from 'ContentComponents/components/cmv2/components/AsyncSelector';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import EditFormControl from 'ContentComponents/components/cmv2/EditFormControl';
import * as SalesforceActions from 'ContentData/actions/Salesforce';
import * as salesforceSelectors from 'ContentData/selectors/salesforce';
import ContentRoutes from 'ContentUtils/Routes';
import { getIntegrationStatusKey } from 'ContentUtils/helpers/PermissionsHelpers';
import { SFDC_CAMPAIGN } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT_PAGE_SIZE, ASYNC_SELECTOR_DEBOUNCE } from 'ContentComponents/components/cmv2/constants';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.salesforcecampaign.${key}`;
const mapStateToProps = (state, props) => {
  return {
    options: salesforceSelectors.getCampaignsOptions(state) || [],
    defaultOptions: salesforceSelectors.getDefaultCampaignsOptions(state) || [],
    integrationStatus: salesforceSelectors.getIntegrationStatus(state, props),
    isIntegrated: salesforceSelectors.getIsIntegrated(state, props)
  };
};
const mapDispatchToProps = {
  fetchCampaign: SalesforceActions.fetchCampaign,
  fetchCampaigns: SalesforceActions.fetchCampaigns,
  fetchIntegrationStatus: SalesforceActions.fetchIntegrationStatus,
  saveCache: SalesforceActions.saveCache,
  clearCache: SalesforceActions.clearCampaigns
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class SalesforceCampaign extends Component {
  constructor(props) {
    super(props);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.handleLoadOptions = this.handleLoadOptions.bind(this);
    this.debouncedLoadOptions = debounce(this.handleLoadOptions, ASYNC_SELECTOR_DEBOUNCE);
    this.state = {
      isLoading: null,
      input: ''
    };
  }
  componentDidMount() {
    const {
      fetchCampaign,
      fetchIntegrationStatus,
      value
    } = this.props;
    fetchIntegrationStatus().catch(err => {
      throw err;
    });
    if (value) {
      fetchCampaign(value).catch(err => {
        throw err;
      });
    }
  }
  onFieldChange(evt) {
    this.props.onFieldChange(evt.target.value);
  }
  handleLoadOptions(input, callback, pagination = {
    offset: 0
  }) {
    let offset = pagination.offset;
    if (input !== this.state.input) {
      this.setState({
        input
      });
      this.props.clearCache();
      offset = 0;
    }
    const query = {
      query: input,
      count: DEFAULT_PAGE_SIZE,
      offset
    };
    this.setState({
      isLoading: true
    });
    this.props.fetchCampaigns(query).then(response => {
      const {
        hasMore
      } = response;
      callback(null, {
        options: this.props.options,
        pagination: {
          hasMore,
          offset: offset + DEFAULT_PAGE_SIZE
        }
      });
      this.setState({
        isLoading: false
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderMessage(key) {
    return /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey(`${key}.label`),
        options: {
          link: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: ContentRoutes.salesforceCampaigns(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`${key}.link`)
            })
          })
        }
      })
    });
  }
  renderEmptyMessage() {
    const {
      isLoading
    } = this.state;
    const {
      isIntegrated,
      options
    } = this.props;
    if (isLoading === false && isIntegrated && !options.length) {
      return this.renderMessage('emptyMessage');
    }
    return undefined;
  }
  renderStatusMessage() {
    const {
      integrationStatus,
      isIntegrated
    } = this.props;
    if (!integrationStatus) {
      return /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('loading.label')
        })
      });
    }
    if (isIntegrated) return null;
    return this.renderMessage(getIntegrationStatusKey(integrationStatus));
  }
  renderCampaignSelect() {
    const {
      isIntegrated,
      defaultOptions,
      options,
      readOnly,
      required,
      saveCache,
      useOnDark,
      value
    } = this.props;
    if (!isIntegrated) return null;
    return /*#__PURE__*/_jsx(AsyncSelector, {
      clearable: !required,
      loadOptions: this.debouncedLoadOptions,
      noResultsText: this.renderEmptyMessage(),
      onChange: this.onFieldChange,
      defaultOptions: defaultOptions,
      options: options,
      placeholder: I18n.text(i18nKey('placeholder.label')),
      readOnly: readOnly,
      saveCache: saveCache,
      searchPromptText: this.renderEmptyMessage(),
      type: SFDC_CAMPAIGN,
      useOnDark: useOnDark,
      value: value
    });
  }
  render() {
    const {
      help_text: helpText,
      inline_help_text: inlineHelpText,
      label,
      required
    } = this.props;
    return /*#__PURE__*/_jsx(EditFormControl, {
      helpText: helpText,
      inlineHelpText: inlineHelpText,
      label: label,
      required: required,
      children: /*#__PURE__*/_jsxs("div", {
        children: [this.renderCampaignSelect(), this.renderStatusMessage()]
      })
    });
  }
}
export default connector(SalesforceCampaign);